import { useQuery } from 'react-query';
import { IPaginationParams } from '../../../types';
import { ISchoolShiftFilterParams } from '../../types';
import {
  getAllSchoolShiftByLicenseAsync,
  getAllSchoolShiftCountAsync,
  getSchoolShiftByIdAsync,
} from '../../index';

export const SCHOOL_SHIFT_KEYS = {
  ALL: 'schoolShift',
  LIST: 'list',
  COUNT: 'count',
  DETAIL: 'detail',
};

const defaultQueryOptions = {
  refetchOnWindowFocus: false,
  staleTime: 1000 * 60,
};

export const useGetAllSchoolShiftByLicenseQuery = (
  pagination?: IPaginationParams,
  filter?: ISchoolShiftFilterParams
) => {
  return useQuery(
    [SCHOOL_SHIFT_KEYS.ALL, SCHOOL_SHIFT_KEYS.LIST, pagination, filter], 
    () => getAllSchoolShiftByLicenseAsync(pagination, filter),
    {
      ...defaultQueryOptions,
      keepPreviousData: true, 
    }
  );
};

export const useGetSchoolShiftCountQuery = (
  filter?: ISchoolShiftFilterParams
) => {
  return useQuery(
    [SCHOOL_SHIFT_KEYS.ALL, SCHOOL_SHIFT_KEYS.COUNT, filter],
    () => getAllSchoolShiftCountAsync(filter),
    {
      ...defaultQueryOptions,
      keepPreviousData: true, 
    }
  );
};

export const useGetSchoolShiftByIdQuery = (id?: number | null) => {
  return useQuery(
    [SCHOOL_SHIFT_KEYS.ALL, SCHOOL_SHIFT_KEYS.DETAIL, id],
    () => getSchoolShiftByIdAsync(id!),
    {
      ...defaultQueryOptions,
      enabled: !!id,
    }
  );
};